import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { RequestStatus } from 'src/app/models/request-status';
import { StatusChange } from 'src/app/models/status-change';
import { AckRequestService } from 'src/app/services/ack-request.service';
import { MyOrdersService } from '../my-orders-table/my-orders-table.service';

@Component({
  selector: 'logzy-request-status-change-form',
  templateUrl: './request-status-change-form.component.html',
  styleUrls: ['../request-reject-form/request-reject-form.component.scss']
})
export class DefaultStatusChangeComponent implements OnInit {
  @Input() headingLabel: string = null;
  @Input() description: string = null;
  @Input() buttonLabel: string = null;
  @Input() showCancel: boolean = false;

  errorObj: any = {};
  modelService: MyOrdersService;
  ackService: AckRequestService;

  @Input()
  changeToStatus: RequestStatus = null;

  @Output() close: EventEmitter<any> = new EventEmitter();
  @Output() updateAction: EventEmitter<any> = new EventEmitter();

  constructor(private ackRequest: AckRequestService,
    private myOrderService: MyOrdersService
    , private snackBar: MatSnackBar,) { }

  statusChangeObject: StatusChange;

  defaultStatus: StatusChange = {
    remarks: null,
    status: null
  }
  ngOnInit(): void {
    this.statusChangeObject = { ...this.defaultStatus };
    this.modelService = this.myOrderService;
    this.ackService = this.ackRequest;
  }

  defaultRequest() {
    if (this.changeToStatus == null) {
      console.error('Abeeee (changeToStatus) tho set kar!!!!!!');
      return;
    }

    this.statusChangeObject.status = this.changeToStatus.id;
    this.ackRequest.requestStatusChange(this.statusChangeObject, this.ackService.selectedRequest.id).subscribe({
      next: response => {
        this.snackBar.open("Request Update Successfully!", 'Close', {
          verticalPosition: 'top',
          duration: 2000,
        });
        // this.modelService.getRequestDetails();
        this.close.emit();
        this.updateAction.emit();
      },
      error: error => {
        return this.catchError(error);
      }
    })
  }
  // Function to catch errors
  catchError(error) {
    if (error.status >= 500) {
      this.errorObj = { ...error.error };
      return error;
    } else if (error.status > 399 && error.status < 500) {
      this.errorObj = { ...error.error };
      return error;
    }
  }

  cancelRequest() {
    this.updateAction.emit();
  }
}
